import { render, staticRenderFns } from "./ForbesBanner.vue?vue&type=template&id=e2702926&scoped=true&"
import script from "./ForbesBanner.vue?vue&type=script&lang=js&"
export * from "./ForbesBanner.vue?vue&type=script&lang=js&"
import style0 from "./ForbesBanner.vue?vue&type=style&index=0&id=e2702926&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2702926",
  null
  
)

export default component.exports